export const availableRoles = {
  INVITE_CLIENTS: 'Invite Clients',
  INVOICE: 'Invoice',
  PREP: 'Prep',
  MESSAGE: 'Message Clients',
  ADMIN: 'Administrator',
}